import React from 'react';

export default function ProductReview() {
  return <div></div>;
}
